<template>
  <div></div>
</template>

<script>
import { query } from '@/libs/utils/util';
import { gotoHome, getUrlDomain } from '@/utils/util';
import login from '@/utils/login.js';
import config from '@/config';

export default {
  name: 'Door',
  created() {
    console.log('进入企业微信扫码登录中转页');
    const code = query('code');
    console.log('code', code);
    this.$store
      .dispatch('login/getLoginConfig')
      .then((res) => {
        login.setStorageType('cookie');
        login
          .qrCodeLogin(code, res.auth_agent_id)
          .then(() => {
            this.$message.success('登陆成功');
            const redirectUri = query('redirect_uri');
            if (redirectUri) {
              // this.g_tourl(decodeURIComponent(atob(redirectUri)), { replace: true, href: true });
              const redirectDomain = getUrlDomain(decodeURIComponent(atob(redirectUri)));
              if (config.domain.includes(redirectDomain)) {
                this.g_tourl(decodeURIComponent(atob(redirectUri)), { replace: true, href: true });
              } else {
                gotoHome();
              }
            } else {
              gotoHome();
            }
          })
          .catch(() => {
            this.$message.error('登录失败');
            const redirectUri = query('redirect_uri');
            this.g_tourl(`/saas/login.html?${redirectUri ? `redirect_uri=${redirectUri}` : ''}`);
          });
      })
      .catch((e) => this.$message.error(e));
  },
};
</script>
